import atoms from "../../atoms";
import { TWarrantyList } from "./interface";

const {CustomImages} = atoms

export const Warranty_Table_Columns = [
    {
        name: "Claim ID",
        selector: (row:TWarrantyList ) => row.claim_id || "-",
        sortable: true,
        minWidth: "120px",
    },
    {
        name: "Picture",
        cell: (row: any) => (
            <CustomImages
                src={row?.product?.images?.length > 0 && row?.product?.images[0]}
                imageHeight="100px"
            />
        ),
        center: true,
    },
    {
        name: "Product Type",
        selector: (row: TWarrantyList) => row?.product?.product_type?.name || "-",
        minWidth: "150px",
    },
    {
        name: "Product ID",
        selector: (row: TWarrantyList) => row?.product?.product_id_display || "-",
        minWidth: "150px",
    },

    {
        name: "Brand",
        selector: (row: TWarrantyList) => row?.product?.brand?.brand_name || "-",
        minWidth: "150px",
    },
    {
        name: "Model Number",
        selector: (row: TWarrantyList) => row?.product?.modal_number || "-",
        minWidth: "150px",
    },
    {
        name: "Brand Color Code",
        selector: (row: TWarrantyList) => row.product?.brand_color_code || "-",
        minWidth: "150px",
    },
    {
        name: "Size/Power",
        selector: (row: TWarrantyList) => `${row.product?.glass_size} MM`,
        minWidth: "150px",
    },

    {
        name: "status",
        selector: (row: any) => row.verification_status,
        minWidth: "100px",
    },

    { name: "Action", selector: (row: any) => row.action, minWidth: "150px" },
];
